<script setup>
// EOR magic-link POC — redeem step. The emailed link lands here with a single-use
// token in the query string; we exchange it for a session token and forward to the
// EOR view. (ClickUp 86ba8whkq.)
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { eorAPI } from '../service/api.js';
import { useMagicLink } from '../composables/useMagicLink';

const route = useRoute();
const router = useRouter();
const { setSession } = useMagicLink();

const status = ref('Verifying your link…');
const error = ref('');

onMounted(async () => {
  const token = route.query.token;
  if (!token) {
    error.value = 'This link is missing its access token.';
    return;
  }
  try {
    const { data } = await eorAPI.redeem(token);
    setSession(data.session_token);
    router.replace(`/eor/${data.eor_id}`);
  } catch (e) {
    console.error('EOR redeem failed:', e);
    error.value = 'This link is invalid, expired, or has already been used. Please request a new one.';
  }
});
</script>

<template>
  <div class="app-container">
    <header class="app-header">
      <div class="header-logo"><img src="/logo.png" width="200" height="50" /></div>
    </header>
    <div class="app-content" style="padding: 2rem;">
      <p v-if="!error">{{ status }}</p>
      <p v-else style="color: #c0392b;">{{ error }}</p>
    </div>
  </div>
</template>
